<template>
  <div class="user-operation__login">
    <h1 class="user-operation__title">
      <span>登录</span>
    </h1>
    <el-form label-width="0" :model="loginFormModel" :rules="rules" ref="loginForm" class="user-operation__login-form">
      <el-form-item prop="cellphone">
        <el-input type="tel" placeholder="请输入手机号" v-model="loginFormModel.cellphone" :maxlength="11" @blur="inputBlurFn('cellphone')"></el-input>
      </el-form-item>
      <el-form-item class="loginPw" prop="loginPassword">
        <el-input type="password" placeholder="请输入密码" v-model="loginFormModel.loginPassword" :maxlength="16" @blur="inputBlurFn('loginPassword')"></el-input>
      </el-form-item>
      <el-form-item class="verification-code" prop="verificationCode">
        <el-input placeholder="请输入验证码" :maxlength="4" v-model="loginFormModel.verificationCode" @keyup.enter.native="submitForm"></el-input>
        <img :src="verificationImageSrc" alt="verification code" ref="verificationCode" v-show="verificationImageSrc" @click="refreshVerificationCode">
      </el-form-item>
      <el-form-item class="user-operation__login-bottom">
        <div class="user-operation__login-links">
          <router-link exact to="/forgetPassword">忘记密码</router-link>
          |
          <router-link exact to="/register">注册</router-link>
        </div>
        <el-button type="primary" :loading="isLogging" class="user-operation__login-submit" @click.enter="submitForm">登录</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
  import placeholders from '../../scripts/placeholders';
  import { mapGetters, mapActions,mapMutations } from 'vuex';
  import * as types from '../../vuex/types';

  // 项目逐步统一 二次封装ajax.js，所有模块各自有独自跟后台接口API，即js代码分层/模块化  hgwn 3/9
  import userApi from '../../api/user'; // 引用用户Api
  import config from '../../config';
  import messageApi from '../../api/message';

  export default {
    data () {
      // todo 抽出去会报错，type = undefined，原因不明，待查
      const assignValidator = (type, trigger = 'blur') => Object.assign({
        required: true,
        trigger
      }, {
        validator: (rules, value, callback, source, options) => {
          this.$store.dispatch(type, {rules, value, callback, source, options});
        }
      });
      return {
        isLogging: false,
        publicKey: '',
        verificationImageSrc: '',
        rules: {
          cellphone: [assignValidator(types.VERIFY_CELLPHONE)],
          loginPassword: [assignValidator(types.VERIFY_LOGIN_PASSWORD)],
          verificationCode: [{
            required: true,
            trigger: 'blur',
            validator: (rules, value, callback, source, options) => {
              this.$store.dispatch(types.VERIFY_LOGIN_VERIFICATION_CODE, {rules, value, callback, source, options}).then((res) => {
                if (res) {
                  // 基本填对而且请求结果表示错误
                  if (Number(res.data.code) === 1) {
                    this.refreshVerificationCode();
                  }
                } else {
                  // 没有成功请求，验证失败
                  this.refreshVerificationCode();
                }
              });
            }
          }]
        },
        // 要不是element ui的限制，form不能接收计算属性，那么根本不应该有这个data
        // 在watch里面commit mutation会导致state被意外修改报错
        loginFormModel: {
          loginPassword: '',
          cellphone: '',
          verificationCode: ''
        }
      };
    },
    computed: {
      ...mapGetters({
        ajaxBaseUrl: types.GET_AJAX_BASE_URL,
        companyInfo: types.GET_COMPANY_INFO
      })
    },
    created () {
      this.$store.state[1].msgNum == 0;
    },
    methods: {
      ...mapActions({
        userLogin: types.USER_LOGIN,
        setAlertMessage: types.SET_FAIL_MESSAGE,
        getIndexInfo: types.GET_INDEX_INFO,
        // getGenerateRSAPublicKey: types.GET_GENERATE_RSA_PUBLIC_KEY
      }),
      ...mapMutations({
        setRegisterContract: types.SET_CONTRACT_STATE
      }),      
      refreshVerificationCode () {
        this.verificationImageSrc = `${config.ajaxBaseUrl}/servlet/ValidCode?rand=${new Date().getTime()}`;
      },
      getunread () {
        messageApi.unRead({
          tokenId: localStorage.getItem('dl_tokenId_bl')
        }).then((res) => {
          if (res.code === 0) {
            this.$store.commit('changeState', res.result);
            this.result = res.result;
          } else {
          }
        }).catch((err) => {
          console.log('err', err);
        });
      },
      openTips() {
        this.setRegisterContract({
          show: true
        });
        /* this.$alert('<strong>'+this.companyInfo.signTips+'</strong>', '温馨提示', {
          dangerouslyUseHTMLString: true
        }); */
      },        
      submitForm () {
        this.getIndexInfo();
        this.$refs.loginForm.validate((valid) => {
          if (valid) {
            const form = this.loginFormModel;
            this.isLogging = true;
            const encrypt = new JSEncrypt();
            encrypt.setPublicKey(this.publicKey);
            const _loginPassword = encodeURI(encrypt.encrypt(form.loginPassword));

            this.userLogin({
              loginName: form.cellphone,
              password: _loginPassword
            }).then((res) => {
              this.isLogging = false;
              if (Number(res.data.code) === 0) {
              // dl_tokenId_bl
                localStorage.setItem('dl_tokenId_bl', res.data.data.token);
                this.getunread();
                this.$router.push('/personalCenter/myLoan_bl/loanLists_bl');
                //location.reload();
                this.openTips();
              } else {
                this.refreshVerificationCode();
              }
            });
          } else {
            setTimeout(() => {
              placeholders.placeHolder(this);
            }, 30);
            return false;
          }
        });
      },
      inputBlurFn (prop) {
        if (event.srcElement) {
          this.loginFormModel[prop] = event.srcElement.value;
        }
      },
      getRSAPublicKey () {
        const _this = this;
        userApi.generateRSAPublicKey(null).then((res) => {
          console.info(res);
          _this.publicKey = res.publicKey;
        });
      }
    },
    mounted () {
      this.refreshVerificationCode();
      this.getRSAPublicKey();
    }
  };
</script>
<style lang="scss">
  .user-operation__login {
    @include userOperationBlockStyle;
  }

  .user-operation__title {
    @include clear;
    margin-bottom: 20px;

    & img {
      float: left;
      line-height: 40px;
      font-size: 14px;
      height: 40px;
    }

    & span {
      float: left;
      margin-left: 16px;
      line-height: 40px;
      font-family: 'MyriadPro-Regular';
      font-size: 20px;
      color: #999;
    }
  }

  .user-operation__login-form {
    @include userOperationFormStyle;
  }

  .user-operation__login-bottom {
    margin-bottom: 0;
  }

  .user-operation__login-links {
    float: left;
    position: absolute;
    bottom: 0;
    color: $orange;
    font-family: 'FZLanTingHei-DB-GBK';
    font-size: 12px;
    line-height: 1;

    & a {
      color: $orange;
    }
  }

  .user-operation__login-submit {
    float: right;
    border: 1px solid $orange;
    width: 120px;
    height: 45px;
    /*line-height: 45px;*/
    //letter-spacing: 18px;
    font-size: 14px;
    background: $orange;

    &:hover, &:focus, &:active {
      border: 1px solid $orange;
      background: $orange;
    }

    & span {
      //margin-right: -18px; // letter spacing fix
    }
  }
  .loginPw .el-input__icon.el-icon-loading{display: none;}
</style>



// WEBPACK FOOTER //
// Login.vue?4e9868f8